import { IncidentModel } from '../models/incident.model';

export class IncidentDialogContext<T extends IncidentModel> {
    constructor(
        public incident: T,
        public isReadOnly: boolean = false,
        public customerNumberId: number = 0,
        public convictionRequestId: number = 0
    ) {
    }
}
